// extracted by mini-css-extract-plugin
module.exports = {"score":"ScoreItem_score__mj4dz","scoreValue":"ScoreItem_scoreValue__3TJgK","scoreLabels":"ScoreItem_scoreLabels__28-tq"};